import { RightSidebar } from './components/RightSidebar';
import { PostCard } from './components/PostCard';
import { CreatePostModal } from './components/CreatePostModal';
import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useSocialStore } from '@/store/socialStore';

export function SocialFeedPage() {
    const { posts, createPost } = useSocialStore();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);


    return (
        <div className="min-h-screen bg-bg text-text-primary flex justify-center pb-20 md:pt-8 animate-fade-in">
            {/* Max Width Container for Feed + Sidebar */}
            <div className="w-full max-w-[935px] flex justify-center md:justify-between px-0 md:px-4">

                {/* Left/Center Column: Feed */}
                <div className="w-full max-w-[500px] md:max-w-[470px] mx-auto md:mx-0">
                    {/* Stories Bar */}
                    <div className="flex gap-4 overflow-x-auto pb-4 mb-4 px-4 md:px-0 no-scrollbar">
                        {/* Current User Story (Add) */}
                        <div
                            onClick={() => setIsCreateModalOpen(true)}
                            className="flex flex-col items-center gap-1 min-w-[64px] cursor-pointer group"
                        >
                            <div className="w-16 h-16 rounded-full p-[2px] bg-white/10 group-hover:bg-gold-500/50 transition-colors">
                                <div className="w-full h-full rounded-full bg-bg-surface border-2 border-bg flex items-center justify-center text-text-muted group-hover:text-gold-500">
                                    <Plus size={24} />
                                </div>
                            </div>
                            <span className="text-[10px] text-text-muted truncate w-full text-center">New Post</span>
                        </div>

                        {/* Mocks */}
                        {[1, 2, 3, 4, 5].map(i => (
                            <div key={i} className="flex flex-col items-center gap-1 min-w-[64px] cursor-pointer">
                                <div className="w-16 h-16 rounded-full p-[2px] bg-gradient-to-tr from-gold-500 to-bg-surface2">
                                    <div className="w-full h-full rounded-full bg-bg border-2 border-bg overflow-hidden">
                                        <img src={`https://i.pravatar.cc/150?u=${i}`} className="w-full h-full object-cover" />
                                    </div>
                                </div>
                                <span className="text-[10px] text-white truncate w-full text-center">user_{i}</span>
                            </div>
                        ))}
                    </div>

                    {/* Feed Stream */}
                    <div className="space-y-4">
                        {posts.map((post, index) => (
                            <div key={post.id} className={`animate-fade-in stagger-${Math.min(index + 1, 8)}`}>
                                <PostCard post={post} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Right Column: Sidebar (Hidden on mobile) */}
                <RightSidebar />
            </div>

            {/* Floating Action Button (Mobile Friendly) */}
            <button
                onClick={() => setIsCreateModalOpen(true)}
                className="fixed bottom-24 right-6 w-14 h-14 rounded-full bg-gold-500 text-bg-900 shadow-[0_10px_30px_rgba(212,175,55,0.4)] flex items-center justify-center hover:scale-110 active:scale-90 transition-all z-40 md:hidden"
            >
                <Plus size={28} strokeWidth={3} />
            </button>

            {/* Modals */}
            <CreatePostModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                onSuccess={(newPost) => createPost(newPost)}
            />
        </div>
    );
}
